import React, { createContext, useState } from 'react';
import PropTypes from 'prop-types';

import { detectLanguage } from '../utils/i18n';

const LOCALES = {
	de: true,
	en: false
};

const validateLocale = locale => {
	locale = typeof locale !== 'string' ? detectLanguage() : locale;

	if (locale in LOCALES) {
		return locale;
	}

	return DEFAULT_LOCALE;
};

export const ALL_LOCALES = Object.keys(LOCALES);
export const DEFAULT_LOCALE = (() => ALL_LOCALES.find(key => !!LOCALES[key]))();

export const LocaleProvider = ({ children, locale }) => {
	const [currentLocale, setCurrentLocale] = useState(validateLocale(locale));

	const validateSetter = locale => {
		locale = validateLocale(locale);
		setCurrentLocale(locale);
	};

	const value = {
		currentLocale,
		locales: ALL_LOCALES,
		defaultLocale: DEFAULT_LOCALE,
		setCurrentLocale: validateSetter
	};

	return <LocaleContext.Provider value={value}>{children}</LocaleContext.Provider>;
};

LocaleProvider.defaultProps = {
	locale: DEFAULT_LOCALE
};

LocaleProvider.propTypes = {
	locale: PropTypes.string
};

const LocaleContext = createContext();

export default LocaleContext;
